module.exports = __webpack_public_path__ + "img/img_20.b9c59620.jpg";